<template>
  <div class="gc-page-project-wrap">
    <van-nav-bar :border="false"
                 title="项目立项审核"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-project-wrap box">
      <div class="item">
        <span>项目名称：</span>{{ detailInfo.Item.Name }}
      </div>
      <div class="item">
        <span>项目编号：</span>{{ detailInfo.Item.Sysno }}
      </div>
      <div class="item">
        <span>项目金额：</span>¥{{ detailInfo.ProALLMoney }}
      </div>
      <div class="item">
        <span>项目时间：</span>{{ detailInfo.PlanStartDate.slice(0, 10) }}至{{ detailInfo.PlanOverTime.slice(0, 10) }}
      </div>
      <div class="item">
        <span>项目标签：</span>{{ detailInfo.ProSource ? '外部' : '内部' }}
      </div>
      <div class="item" style="display:block">
        <span>项目描述</span>
        <div class="tip">
          {{ detailInfo.ProRemark }}
        </div>
      </div>
    </div>
    <div class="page-dep-wrap box">
      <div class="item arr" @click="showMoneyType=true">
        <span>出资类型</span>
        {{ columnsType[moneyType] }}
      </div>
      <div class="item arr" v-if="moneyType==1" @click="showMembers=true">
        <span>出资人员：</span>
        请选择
      </div>
      <div class="page-member-wrap" v-if="activeNames.length>0&&moneyType==1">
        <div class="title">
          <span class="s1">已选出资人员</span>
          <span class="s2">权重</span>
          <span class="s2">金额</span>
        </div>
        <div class="info-wrap">
          <div class="info-item" v-for="(item,index) in activeNames" :key="index">
            <span class="s1">{{ item.dep }}-{{ item.name }}</span>
            <span class="s2">
                            <div class="input-wrap">
                                <!-- <input type="number" v-model="item.scale" class="input" @keyup="item.scale>100?item.scale=100:''"><i>%</i>  -->
                                <div class="input" @click="showWeightPicker(index)">{{ item.scale ? item.scale : '请选择' }}<i>%</i></div>
                            </div>
                        </span>
            <span class="s2">{{ Number(item.scale / 100 * detailInfo.ProALLMoney).toFixed(2) }}</span>
          </div>
          <!-- <div class="info-item">
              <span class="s1">合计</span>
              <span class="s2">{{allWeight}}%</span>
              <span class="s2"></span>
          </div>   -->
        </div>
      </div>
    </div>

    <div class="page-dep-wrap box">
      <div class="item arr" @click="showMemberOne=true">
        <span>验收人员：</span>
        {{ activeNameOne }}
      </div>
    </div>

    <div class="review-btn">
      <div class="btn btn1" @click="handleReview(0)">驳 回</div>
      <div class="btn btn2" @click="handleReview(1)">通 过</div>
    </div>
    <!-- 验收人员 -->
    <van-popup v-model="showMemberOne" position="bottom">
      <div class="opt-btn">
        <div class="cancel" @click="showMemberOne=false">取消</div>
        <div class="sure" @click="showMemberOne=false">确定</div>
      </div>
      <van-tree-select
        :items="items"
        :active-id.sync="activeId"
        :main-active-index.sync="activeIndexOne"
        @click-item="handleTree"
      />
    </van-popup>
    <!-- 出资人员 -->
    <van-popup v-model="showMembers" @close="handleClose" position="bottom">
      <div class="opt-btn">
        <div class="cancel" @click="showMembers=false">取消</div>
        <div class="sure" @click="showMembers=false">确定</div>
      </div>
      <van-tree-select
        :items="items"
        :active-id.sync="activeIds"
        :main-active-index.sync="activeIndex"
      />
    </van-popup>
    <!-- 出资类型 -->
    <van-popup v-model="showMoneyType" position="bottom">
      <van-picker
        show-toolbar
        :columns="columnsType"
        @confirm="onConfirmType"
        @cancel="showMoneyType=false"
        :default-index="moneyType"
      />
    </van-popup>
    <!-- 选择权重 -->
    <van-popup v-model="showWeight" position="bottom">
      <van-picker
        ref="weight"
        show-toolbar
        :columns="columnsWeight"
        @confirm="onConfirmWeight"
        @cancel="showWeight=false"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailInfo: {
        Item: {
          Name: ''
        },
      },
      showMembers: false,
      showMemberOne: false,
      showMoneyType: false,
      moneyType: 1,
      columnsType: ['全体人员', '部分人员', '外部项目'],
      items: [
        // {
        //     text:'技术中心',
        //     children: [{
        //         text:'陈军1',
        //         id: 1
        //     },{
        //         text:'陈军2',
        //         id: 2
        //     }]
        // },
        // {
        //     text:'技术中心',
        //     children: [{
        //         text:'陈军3',
        //         id: 3
        //     },{
        //         text:'陈军4',
        //         id: 4
        //     }]
        // }
      ],
      activeId: '',
      activeIds: [],
      activeNameOne: '请选择',
      activeNames: [],
      tempActiveNames: [],
      activeIndexOne: 0,
      activeIndex: 0,
      dis: '',
      // 权重
      showWeight: false,
      weightActiveIndex: 0,
      columnsWeight: [],
    }
  },
  mounted() {
    this.WebGetDealProjectInfoEx()
    this.WebGetBDepInfo()

    for (let i = 1; i <= 100; i++) {
      this.columnsWeight.push(i)
    }
  },
  // computed:{
  //     allWeight(){
  //         let all = 0
  //         if(this.activeNames){
  //             for(let item of this.activeNames){
  //                 all += Number(item.scale)
  //             }
  //         }
  //         return all
  //     }
  // },
  methods: {
    // 项目详情
    WebGetDealProjectInfoEx() {
      let data = {
        DepSysno: this.$route.params.sysno,
        UserId: localStorage.getItem('UserSysno')
      }
      this.$baseajax.normalJsonp(this.$base.baseProject + '/WebGetDealProjectInfoEx', data, res => {
        console.log(res);
        res = res.WebGetDealProjectInfoExResult
        if (res.ResponseCode == 1) {
          this.detailInfo = res.Item;
        }
      }, err => {
      })
    },

    // 立项审核
    WebUpdateSureProInfo(status) {
      let ItemLst = []
      for (let obj of this.activeNames) {
        ItemLst.push({
          UserSysno: obj.id,  //编号
          PayMoneyRand: Number(obj.scale), //出资权重
          PayMoney: obj.scale / 100 * this.detailInfo.ProALLMoney //出资金额
        })
      }
      let data = {
        Item: {
          ProSysno: this.$route.params.sysno,
          ProMoneyType: this.moneyType, //类型 0全体人员  1部分人员  2外部项目
          ProStatus: status,//0不通过  1通过
          ItemLst: ItemLst || '', //出资人员
          Acceptance: this.activeId //验收人员
        }
      }
      this.$baseajax.sliceRequest(this.$base.baseProject + '/WebUpdateSureProInfo', data, res => {
        console.log(res);
        if (res.ResponseCode == 1) {
          this.$toast('审核完成')
          this.$router.back()
        } else {
          this.$toast(res.ResponseMessage)
        }
      }, err => {
      })
    },
    // 审核通过、不通过
    handleReview(status) {
      if (status == 1) {
        if (this.moneyType == 1) {
          if (this.activeNames.length == 0) {
            this.$toast('请选择出资人员')
            return
          }

          let percent = 0
          for (let obj of this.activeNames) {
            percent += Number(obj.scale)
          }
          if (percent != 100) {
            this.$toast('出资权重和一定要等于100')
            return
          }
        }
        if (this.activeId == '') {
          this.$toast('请选择验收人员')
          return
        }
      }
      this.$dialog.confirm({
        title: '提示',
        message: '确认操作吗？',
        confirmButtonColor: '#D32F2F'
      }).then(() => {
        this.WebUpdateSureProInfo(status)
      }).catch(() => {
      })

    },
    // 出资人员
    handleClose() {
      this.activeNames = []
      for (let item of this.activeIds) {
        this.activeNames.push({
          id: item,
          scale: 0
        })
      }
      for (let item of this.tempActiveNames) {
        this.activeNames.map(item2 => {
          if (item2.id == item.id) {
            item2.scale = item.scale
          }
          return item2
        })
      }
      // 对应名字
      for (let item of this.items) {
        for (let item2 of item.children) {
          this.activeNames.map(item3 => {
            if (item3.id == item2.id) {
              item3.name = item2.text
              item3.dep = item.text
            }
            return item3
          })
        }
      }
      this.tempActiveNames = this.activeNames

    },
    // 验收人员
    handleTree(e) {
      this.activeNameOne = e.text;
    },

    // 获取部门信息
    WebGetBDepInfo() {
      let data = {
        page: 1,
        pcount: 100
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebGetBDepInfo', data, res => {
        console.log(res);
        res = res.WebGetBDepInfoResult
        if (res.ResponseCode == 1) {
          for (let obj of res.ItemLst) {
            this.items.push({
              text: obj.DepInfo.Name,
              id: obj.DepInfo.Sysno,
              children: []
            })
          }
          // 获取人员列表
          this.WebGetItemLst()
        }
      }, err => {
      })
    },
    // 获取人员列表
    WebGetItemLst() {
      let data = {
        page: 1,
        pcount: 100
      }
      this.$baseajax.normalJsonp(this.$base.baseapi + '/WebGetItemLst', data, res => {
        console.log(res);
        res = res.WebGetItemLstResult
        if (res.ResponseCode == 1) {
          for (let obj of res.ItemLst) {
            this.items.map(item2 => {
              if (obj.GovDepItem.Sysno == item2.id) {
                item2.children.push({
                  text: obj.Item.Name,
                  id: obj.Item.Sysno
                })
              }
              return item2
            })
          }
          console.log(this.items);
        }
      }, err => {
      })
    },
    onConfirmType(v, i) {
      console.log(v, i);
      this.moneyType = i
      this.showMoneyType = false
    },
    //选择权重
    showWeightPicker(index) {
      this.weightActiveIndex = index
      this.showWeight = true
      let v = this.activeNames[this.weightActiveIndex].scale ? this.activeNames[this.weightActiveIndex].scale : 1
      this.$nextTick(() => {
        this.$refs.weight.setValues([v]);
      })

    },
    onConfirmWeight(v) {
      this.activeNames[this.weightActiveIndex].scale = v
      this.showWeight = false
    }
  },
}
</script>
<style lang="less" scoped>
.gc-page-project-wrap {
  .page-dep-wrap {
    .item {
      display: flex;
      justify-content: space-between;
      position: relative;

      &.arr {
        padding-right: 0.3rem;

        &:after {
          display: block;
          position: absolute;
          right: 0;
          top: 50%;
          margin-top: -0.1rem;
          content: '';
          width: 0.2rem;
          height: 0.2rem;
          border-top: 0.02667rem solid #999999;
          border-left: 0.02667rem solid #999999;
          -webkit-transform: rotate(135deg);
          transform: rotate(135deg);
        }
      }
    }
  }

  .page-member-wrap {
    margin-right: 0;
    padding-right: 0;
    padding-top: .1rem;
  }

  .review-btn .btn.dis {
    background: #ddd;
    border-color: #ddd;
  }
}

.opt-btn {
  display: flex;
  font-size: .34rem;
  justify-content: space-between;
  padding: .25rem;
  // background: #fcfcfc;
  border-bottom: 1px solid #f5f5f5;

  .sure {
    color: #ee0a24;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/project/ReviewStart.vue